/**
 * @generated SignedSource<<cdc14be1d2d19dca5c3f50a47b1c81a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchTalentPosition_AtlassianSearchPage$data = {
  readonly __typename: string;
  readonly id: string;
  readonly position?: {
    readonly __typename: "RadarPosition";
    readonly fieldValues: ReadonlyArray<{
      readonly fieldId: string;
      readonly fieldValue: {
        readonly __typename: "RadarAriFieldValue";
        readonly __typename: "RadarAriFieldValue";
        readonly value: {
          readonly __typename: "MercuryFocusArea";
          readonly " $fragmentSpreads": FragmentRefs<"positionFocusArea_AtlassianSearchPage">;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      } | {
        readonly __typename: "RadarStringFieldValue";
        readonly __typename: "RadarStringFieldValue";
        readonly stringValue: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
    }>;
    readonly worker: {
      readonly preferredName: string | null | undefined;
      readonly user: {
        readonly picture: AGG$URL;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchTalentPosition_AtlassianSearchPage";
};
export type searchTalentPosition_AtlassianSearchPage$key = {
  readonly " $data"?: searchTalentPosition_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchTalentPosition_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchTalentPosition_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "RadarPosition",
          "kind": "LinkedField",
          "name": "position",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "concreteType": "RadarWorker",
              "kind": "LinkedField",
              "name": "worker",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "preferredName"
                },
                {
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "picture"
                    }
                  ]
                }
              ]
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "fieldIdIsIn",
                  "value": [
                    "positionId",
                    "positionStatus",
                    "positionJobTitle",
                    "positionPositionTitle",
                    "positionKey",
                    "positionExternalPositionKey",
                    "positionWorker",
                    "focusArea"
                  ]
                }
              ],
              "concreteType": "RadarFieldValueIdPair",
              "kind": "LinkedField",
              "name": "fieldValues",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                },
                {
                  "kind": "LinkedField",
                  "name": "fieldValue",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": "stringValue",
                          "kind": "ScalarField",
                          "name": "value"
                        }
                      ],
                      "type": "RadarStringFieldValue"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "value",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "FragmentSpread",
                                  "name": "positionFocusArea_AtlassianSearchPage"
                                }
                              ],
                              "type": "MercuryFocusArea"
                            }
                          ]
                        }
                      ],
                      "type": "RadarAriFieldValue"
                    }
                  ]
                }
              ],
              "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
            }
          ]
        }
      ],
      "type": "SearchResultTalentPosition"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};
})();

(node as any).hash = "4b2c420e8a8fe59c29a7e5a6a9af5ed0";

export default node;
